import React from "react";
import Section1 from "../components/Allproducts/Section1";
import data from '../json/Allproducts/Vedas1.json'
import Section2 from "../components/Allproducts/Section2";
import Section4 from "../components/Allproducts/Section4";

const Vedas = () => {
  return (
    <div className="w-full flex flex-col items-center ruler">

      <Section1 data={data}/>
      <Section2 data={data.Section3}/>
      <Section4 data={data.Section4}/>
    </div>
  );
};

export default Vedas;
